import { contractorApi } from '@/lib/api'

export function downloadTaxForm({ taxFormId }: { taxFormId: string }) {
  return contractorApi.get(`/v1/my/tax-forms/${taxFormId}`, {
    responseType: 'blob',
  })
}
